module.exports = __webpack_public_path__ + "static/media/Dan.34e05fe1.jpeg";